import axios from 'axios';

// Axios instance for cookie-based session auth
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api',
  timeout: 40000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Lightweight interceptors kept for future extension
// apiClient.interceptors.request.use((config) => config, (error) => Promise.reject(error));
// apiClient.interceptors.response.use((response) => response, (error) => Promise.reject(error));

export default apiClient;
